import script from "./AccountAi.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountAi.vue?vue&type=script&setup=true&lang=js"

import "./AccountAi.vue?vue&type=style&index=0&id=7bbba009&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbba009"]])

export default __exports__